<template>
  <div class="stepper-wrapper">
    <div
      class="stepper d-flex justify-content-between align-items-center px-3 mb-2"
    >
      <div
        v-for="(_, index) in labels"
        :key="`${index}`"
        class="d-flex align-items-center"
        :class="{ 'w-100': index < labels.length - 1 }"
      >
        <span
          class="rounded-pill d-flex justify-content-center align-items-center active-container"
          v-if="step === index + 1"
        >
          <IconStepperActive />
        </span>
        <span class="done" v-else-if="step > index + 1">
          <IconStepperDone />
        </span>
        <IconStepperInactive v-else />
        <div
          class="stepper-line"
          :style="step > index + 1 && 'background-color:#213e7a'"
          v-if="index < labels.length - 1"
        ></div>
      </div>
    </div>

    <div class="stepper d-flex justify-content-between align-items-center">
      <p v-for="label in labels" :key="label">
        {{ label }}
      </p>
    </div>
  </div>
</template>

<script>
import IconStepperActive from "./Iconsvg/IconStepperActive.vue";
import IconStepperDone from "./Iconsvg/IconStepperDone.vue";
import IconStepperInactive from "./Iconsvg/IconStepperInactive.vue";

export default {
  components: { IconStepperDone, IconStepperActive, IconStepperInactive },
  name: "Stepper",
  props: {
    step: Number,
    labels: Array,
  },
};
</script>

<style scoped>
.stepper-line {
  height: 2px;
  /* width: 50%; */
  background-color: #eff0f7;
  width: calc(100% - 28px);
}

.active-container {
  height: 35px;
  width: 35px;
  background: #eff0f7;
}

/* @media (min-width: 768px) {
  .stepper-wrapper {
    padding:0 1rem;
  }
}

@media (min-width: 1600px) {
    .stepper-wrapper {
    padding:0 2rem;
  }
} */
</style>
